import React from 'react';

export const TiktokIcon = ({ fill }: { fill?: string }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="100%" viewBox="0 0 36 36">
      <g data-name="Group 3110">
        <path
          data-name="Path 13665"
          d="M18.613 0a18 18 0 1 0 18 18 18 18 0 0 0-18-18z"
          transform="translate(-.613)"
          style={{ fill: fill || '#181d56' }}
        />
        <path
          data-name="Path 13666"
          d="M130.458 127.787a5.8 5.8 0 0 0 3.6 1.247 5.9 5.9 0 0 0 .884-.066 5.813 5.813 0 0 0 3.274-1.675 5.941 5.941 0 0 0 1.722-4.18l-.016-7.012a7.707 7.707 0 0 0 1.722 1.028 7.6 7.6 0 0 0 3.032.625v-3.123h-.009a4.663 4.663 0 0 1-2.859-.978 4.867 4.867 0 0 1-1.8-2.925 4.989 4.989 0 0 1-.091-.908h-3.066V123.092a2.834 2.834 0 0 1-1.907 2.694 2.723 2.723 0 0 1-2.3-.259 2.852 2.852 0 0 1-1.357-2.393 2.811 2.811 0 0 1 2.781-2.881 2.731 2.731 0 0 1 .875.144v-3.185a5.9 5.9 0 0 0-.884-.067 5.823 5.823 0 0 0-4.419 2.022 5.994 5.994 0 0 0 .26 8.129 6.02 6.02 0 0 0 .558.491z"
          transform="translate(-118.431 -101.427)"
          style={{ fill: '#fff' }}
        />
      </g>
    </svg>
  );
};
